<app-header></app-header>
<router-outlet></router-outlet>
<!-- <ng-http-loader [spinner]="skThreeBounce" *ngIf="activeComponent != 'DetailEpisodeComponent'"></ng-http-loader> -->
<app-footer></app-footer>
